import { useMemo } from "react";
import UpdatePositions from "./UpdatePositions";
import { useNavigate } from "react-router";

export default function UpdatePositionsPage() {
  const navigate = useNavigate();

  const dealTicketId = useMemo(() => {
    const id = new URLSearchParams(location.search).get('dealTicketId');
    return id ? parseInt(id, 10) : undefined;
  }, [location.search]);

  
  function cancel() {
    console.log('cancel');
    navigate('/commodity-management/positions');
  }

  return <UpdatePositions dealTicketId={dealTicketId} onCancel={cancel}/>;
}